import { postInfo, getInfo } from './api';

export default {
  reqLoginPostUserLogin(data) { // 获取菜单
    return postInfo('/auth2/token/user', data);
  },
  reqLoginPosSystemPrivileges(data) {
    return postInfo('/auth2/authTree/bySystem', data);
  },
  reqLoginPostDictionaryBySystem(data) {
    return getInfo('/common/dictionary/bySystem/14', data);
  },
  reqStaffInfo(data, join) { // 员工信息
    return getInfo(`/hr/staff/${join}`, data);
  },
  // 是否需要验证码登录
  isVerification() {
    return getInfo('/auth2/login/switch');
  },
  // 获取登录验证码
  getVerification(join) {
    return getInfo(`/auth2/login/${join}`);
  },
};
